import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";
import type { SubmitAdvertiserIdRequest } from "../../../../zodios/apiDefinitions/api/walmart";
import { useAdvertiserVerificationError, type AdvertiserVerificationError } from "../useAdvertiserVerificationError";

export const useSubmitWalmartAdvertiserId = (options?: {
  onSuccess?: () => void;
  onError?: (error: AdvertiserVerificationError) => void;
}) => {
  const queryClient = useQueryClient();
  const describeError = useAdvertiserVerificationError();

  return useMutation({
    mutationFn: async (params: SubmitAdvertiserIdRequest) => await apiClient.submitWalmartAdvertiserId(params),
    onSuccess: () => {
      options?.onSuccess?.();
    },
    onError: (error) => {
      options?.onError?.(describeError(error));
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ["walmart-onboarding-status"] });
    },
  });
};
